import { CreateCallRatingInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const CreateCallRatingInputSchema: z.ZodType<CreateCallRatingInput> =
  z.object({
    rating: z.number().int().min(1).max(5),
    description: z.string(),
    appointment_id: z.number().int().positive(),
    trouble: z.boolean(),
  });
